import { render, staticRenderFns } from "./EntranceTeacherCreate.vue?vue&type=template&id=cd9bbcf6&scoped=true&"
import script from "./EntranceTeacherCreate.vue?vue&type=script&lang=ts&"
export * from "./EntranceTeacherCreate.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceTeacherCreate.vue?vue&type=style&index=0&id=cd9bbcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9bbcf6",
  null
  
)

export default component.exports